import { isFunction, get } from '@antv/util';
import { Params } from '../../core/adaptor';
import { tooltip, interaction, animation, theme, scale, state } from '../../adaptor/common';
import { flow, deepAssign } from '../../utils';
import { point } from '../../adaptor/geometries';
import { WordCloudOptions } from './types';
import { transform } from './utils';
import { WORD_CLOUD_COLOR_FIELD } from './constant';

/**
 * geometry éç½®å¤ç
 * @param params
 */
function geometry(params: Params<WordCloudOptions>): Params<WordCloudOptions> {
  const { chart, options } = params;
  const { colorField, color } = options;
  const data = transform(params);

  chart.data(data);

  const p = deepAssign({}, params, {
    options: {
      xField: 'x',
      yField: 'y',
      seriesField: colorField && WORD_CLOUD_COLOR_FIELD,
      rawFields: isFunction(color) && [...get(options, 'rawFields', []), 'datum'],
      point: {
        color,
        shape: 'word-cloud',
      },
    },
  });

  const { ext } = point(p);
  ext.geometry.label(false);

  chart.coordinate().reflect('y');
  chart.axis(false);

  return params;
}

/**
 * meta éç½®
 * @param params
 */
function meta(params: Params<WordCloudOptions>): Params<WordCloudOptions> {
  return flow(
    scale({
      x: { nice: false },
      y: { nice: false },
    })
  )(params);
}

/**
 * è¯äºå¾ legend éç½®
 * @param params
 */
export function legend(params: Params<WordCloudOptions>): Params<WordCloudOptions> {
  const { chart, options } = params;
  const { legend, colorField } = options;

  if (legend === false) {
    chart.legend(false);
  } else if (colorField) {
    chart.legend(WORD_CLOUD_COLOR_FIELD, legend);
  }

  return params;
}

/**
 * è¯äºå¾ééå¨
 * @param chart
 * @param options
 */
export function adaptor(params: Params<WordCloudOptions>) {
  // flow çæ¹å¼å¤çææçéç½®å° G2 API
  flow(geometry, meta, tooltip, legend, interaction, animation, theme, state)(params);
}
